import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utils/css-class';
import type { PlanV2 } from '@/types/virtual-lab/pricing';
export default function SubscriptionsCosts(t0) {
  const $ = _c(9);
  const {
    billingInterval,
    plan,
    isCurrentTier
  } = t0;
  const borderColor = isCurrentTier ? "border-primary-7" : "border-neutral-2";
  let t1;
  if ($[0] !== borderColor) {
    t1 = cn("relative my-2 w-full border-y py-2", borderColor);
    $[0] = borderColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== billingInterval || $[3] !== plan.monthly_subscriptions || $[4] !== plan.yearly_subscriptions) {
    t2 = billingInterval === "month" ? <div><span className="text-2xl font-bold">{plan.monthly_subscriptions[0].currency} {plan.monthly_subscriptions[0].price}</span><span className="relative ml-2 text-base font-normal">/ {plan.monthly_subscriptions[0].name}</span>{" "}</div> : <div><span className="text-2xl font-bold">{plan.yearly_subscriptions[0].currency} {plan.yearly_subscriptions[0].price}</span><span className="relative ml-2 text-base font-normal">/ {plan.yearly_subscriptions[0].name}</span>{" "}</div>;
    $[2] = billingInterval;
    $[3] = plan.monthly_subscriptions;
    $[4] = plan.yearly_subscriptions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}